import * as S from "./InputLogin.style";
import { InputProps } from "..";
import { ChangeEvent } from "react";

interface InputLoginProps extends InputProps {
  type: "text" | "password";
  max?: string;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  tabIndex?: number;
  field: any;
}

export const InputLogin = (props: InputLoginProps) => {
  const inputId = `login-input-${props.field.name}`;

  return (
    <S.LoginInputs>
      <S.Input
        id={inputId}
        type={props.type}
        placeholder={props.placeholder}
        max={props.max}
        tabIndex={props.tabIndex}
        autoCapitalize="none"
        {...props.field}
      />
      <S.Label htmlFor={inputId}>{props.label}</S.Label>
    </S.LoginInputs>
  );
};
